export default {
	text: "{changedBy} changed the sort order of this KR from {from} to {to}",
};
